import { useState } from "react";

const RatingStars = ({ starHeight, containerWidth, ratingPercent }) => {
  const [Pwidth] = useState(containerWidth || "142px");
  const [Aheight] = useState(starHeight || "26px");
  const numberOfstars = 5; // Or something else

  return (
    <>
      <div
        className={"starsURContainer"}
        style={{ width: Pwidth, height: Aheight }}
      >
        <div className={"activeStarsUR"} style={{ width: ratingPercent }}>
          {[...Array(numberOfstars)].map((e, i) => (
            <span key={i} style={{ minWidth: Aheight }}></span>
          ))}
        </div>
        <div className={"inactiveStarsUR"}>
          {[...Array(numberOfstars)].map((e, i) => (
            <span key={i} style={{ minWidth: Aheight }}></span>
          ))}
        </div>
      </div>
    </>
  );
};

export default RatingStars;
